module.exports = __webpack_public_path__ + "static/media/29820005-wDC0wSgs.dda141c1.JPG";